import { render } from "./TemplateList.vue?vue&type=template&id=025f802c"
import script from "./TemplateList.vue?vue&type=script&lang=ts"
export * from "./TemplateList.vue?vue&type=script&lang=ts"
script.render = render

export default script